module.exports = __webpack_public_path__ + "img/s.650b09b3.jpg";